export const PAGE_SIZE = 20;
export const INITIAL_PERIOD = { year: 2016, quarter: 2 };
